import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomAuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(CustomAuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    // Token vencido guardado: limpa e avisa no login. Sem token, vai ao login normalmente.
    if (authService.hasExpiredSession()) {
      authService.expireSession();
    } else {
      router.navigate(['/login']);
    }
    return false;
  }
  return true;
};
